<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					:model="searchForm"
					@submit.native.prevent
        >
          <el-form-item label="现金账户名称:">
            <el-input 
							v-model.trim="searchForm.cashaccountname" 
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
          <el-form-item label="所属教学点:">
            <el-input 
							v-model.trim="searchForm.schoolorgname"
							 @keyup.enter.native="seach"
							clearable />
          </el-form-item>
					<el-form-item label="存款金额:">
					  <el-input 
							v-model.trim="searchForm.amount" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
					<el-form-item label="操作人:">
					  <el-input 
							v-model.trim="searchForm.username" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      border
			stripe
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column
        label="现金账户名称"
        prop="cashaccountname"
        align="center"
      >
        <template slot-scope="scope">
          <el-button @click="btnShowDetail(scope.row)" type="text">{{
            scope.row.cashaccountname
          }}</el-button>
        </template>
      </el-table-column>

      <el-table-column label="存款金额" prop="amount" align="center" />

      <el-table-column
        label="现金账户当前余额"
        prop="cashcuramount"
        align="center"
      />
      <el-table-column label="折号" prop="bankaccountbookno" align="center" />
      <el-table-column label="卡号" prop="bankaccountcardno" align="center" />
      <el-table-column
        label="银行账户当前余额"
        prop="bankcuramount"
        align="center"
      />
      <el-table-column label="操作时间" align="center" width="160">
        <template slot-scope="scope">
          {{ scope.row.optime | formatDate("YYYY-MM-DD HH:mm:ss") }}</template
        >
      </el-table-column>
      <el-table-column label="操作人名称" prop="username" align="center" />
      <el-table-column
        label="所属教学点名称"
        prop="schoolorgname"
        align="center"
      />
      <el-table-column
        label="所属分公司名称"
        prop="companyorgname"
        align="center"
      />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
      width="60%"
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
			:title="this.dialogTitle"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="35%"
        class="demo-dynamic form-item-w-50"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="companyorgname" label="所属分公司">
          <el-select
            v-model="dynamicValidateForm.companyorgname"
            placeholder="请选择"
            :disabled="!$store.state.login.isMaxAuth"
            clearable
            @change="onChangeCompany($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.companyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolorgname" label="所属教学点">
          <el-select
            v-model="dynamicValidateForm.schoolorgname"
            placeholder="请选择"
            clearable
            @change="onChangeSchool($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.schoolList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户名称:" prop="cashaccountname">
          <el-input v-model="dynamicValidateForm.cashaccountname" disabled />
          <el-button
            type="primary"
            class="select-btn"
            @click="onSelectData(account_dialogcashresult, 'showBanknameModal')"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="当前金额">
          <el-input v-model="dynamicValidateForm.cashcurmoney" disabled />
        </el-form-item>
        <el-form-item label="现金账户所属分公司">
          <el-input v-model="dynamicValidateForm.companyorgnamecash" disabled />
        </el-form-item>
        <el-form-item label="现金账户所属教学点">
          <el-input v-model="dynamicValidateForm.schoolorgnamecash" disabled />
        </el-form-item>
        <el-form-item label="开户名称:" prop="bankaccountaccountname">
          <el-input
            v-model="dynamicValidateForm.bankaccountaccountname"
            disabled
          />
          <el-button
            type="primary"
            class="select-btn"
            @click="
              onSelectData(account_dialogbankresult, 'showAccountnameModal')
            "
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="dynamicValidateForm.cardno" disabled />
        </el-form-item>
        <el-form-item label="银行账户当前金额" prop="bankaccountcurmoney">
          <el-input
            v-model="dynamicValidateForm.bankaccountcurmoney"
            disabled
          />
        </el-form-item>
        <el-form-item label="存款金额:" prop="amount">
          <el-input v-model.trim="dynamicValidateForm.amount" clearable/>
        </el-form-item>
        <el-form-item label="存款时间" prop="optime">
          <el-date-picker
            v-model="dynamicValidateForm.optime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择取现时间"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 银行账户 -->
    <el-dialog
      class="btn-2b5a95"
      width="77%"
			v-dialogDrag
      title="银行账户"
			:close-on-click-modal='false'
      :visible.sync="showAccountnameModal"
      v-if="showAccountnameModal"
      append-to-body
    >
      <el-button
        type="primary"
        @click="onConfirmAccountname('showAccountnameModal')"
        >确定</el-button
      >

      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="开户名称:" prop="accountname">
              <el-input 
								v-model.trim="selectSearchForm.accountname" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
            <el-form-item label="银行:" prop="bankname">
              <el-input 
								v-model.trim="selectSearchForm.bankname" 
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
            </el-form-item>
            <el-form-item label="银行卡号:" prop="cardno">
              <el-input 
								v-model.trim="selectSearchForm.cardno"
								 @keyup.enter.native="onSelectSearchClick(
								   selectTableUrl,
								   null,
								   Object.assign({}, selectSearchForm)
								 )"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>

      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				border
				:key="key"
				stripe
				:header-cell-style="{background: '#004d8c', color:'#FFFFFF'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          label="流水号"
          prop="id"
          align="center"
          width="200px"
        />
        <el-table-column
          label="开户名称"
          prop="accountname"
          align="center"
          width="250px"
        />
         <el-table-column
          label="余额"
          prop="curmoney"
          align="center"
          width="200px"
        />
        <el-table-column label="现金/银行" align="center" width="100px">
          <template slot-scope="scope">
            {{ bankorcash[scope.row.bankorcash] }}
          </template>
        </el-table-column>
        <el-table-column
          label="卡号"
          prop="cardno"
          align="center"
          width="200px"
        />
        <el-table-column
          label="所属教学点"
          prop="schoolorgname"
          align="center"
          width="200px"
        />
      </el-table>


      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(val, Object.assign({}, selectSearchForm))
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <!-- 现金账户 -->
    <el-dialog
      class="btn-2b5a95"
			:close-on-click-modal='false'
      width="70%"
			v-dialogDrag
      title="现金账户"
      :visible.sync="showBanknameModal"
      v-if="showBanknameModal"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmBankname('showBanknameModal')"
        >确定</el-button
      >

      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="账户:" prop="accountname">
              <el-input 
								v-model.trim="selectSearchForm.accountname" 
								@keyup.enter.native="onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )"
								clearable />
            </el-form-item>
            <el-form-item label="所属教学点:" prop="schoolorgname">
              <el-input 
								v-model.trim="selectSearchForm.schoolorgname" 
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="
              onSelectSearchClick(
                selectTableUrl,
                null,
                Object.assign({}, selectSearchForm)
              )
            "
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>
      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				border
				stripe
				:key="key"
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="账户名称" prop="accountname" align="center" />
        <el-table-column label="状态" prop="status" align="center" />
        <el-table-column
          label="所属分公司名称"
          prop="companyorgname"
          align="center"
        />
        <el-table-column
          label="所属教学点名称"
          prop="schoolorgname"
          align="center"
        />
      </el-table>
      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(val, Object.assign({}, selectSearchForm))
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <Export
      :exportTitle="'教师管理'"
      :transferDialog="transferDialog"
      :exportUrl="exportUrl"
      :exportexcelUrl="exportexcelUrl"
      :exportsaveUrl="exportsaveUrl"
      :searchForm="searchForm"
      @onCloseExport="onCloseExport"
    ></Export>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
			:close-on-click-modal='false'
      width="60%"
			title="详情"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
      append-to-body
    >
      <table border="1" cellpadding="10" cellspacing="0" class="base_table">
        <tr>
          <td>金额：{{ dynamicValidateForm.amount }}</td>
          <td>操作时间：{{ dynamicValidateForm.optime|formatDate("YYYY-MM-DD HH:mm:ss")}}</td>
          <td>现金账户当前余额：{{ dynamicValidateForm.cashcuramount }}</td>
        </tr>
        <tr>
          <td>银行账户当前余额：{{ dynamicValidateForm.bankcuramount }}</td>
          <td>所属教学点序号：{{ dynamicValidateForm.schoolorgcode }}</td>
          <td>所属教学点名称：{{ dynamicValidateForm.schoolorgname }}</td>
        </tr>
        <tr>
          <td>所属分公司序号：{{ dynamicValidateForm.companyorgcode }}</td>
          <td>所属分公司名称：{{ dynamicValidateForm.companyorgname }}</td>
          <td>开户名称：{{ dynamicValidateForm.bankaccountaccountname }}</td>
        </tr>
        <tr>
          <td>
            银行账户当前金额：{{ dynamicValidateForm.bankaccountcurmoney }}
          </td>
          <td>银行卡号：{{ dynamicValidateForm.bankaccountcardno }}</td>
          <td>存折号：{{ dynamicValidateForm.bankaccountbookno }}</td>
        </tr>
        <tr>
          <td>银行名称：{{ dynamicValidateForm.bankaccountbankname }}</td>
          <td>员工编号：{{ dynamicValidateForm.usercode }}</td>
          <td>员工账户名：{{ dynamicValidateForm.username }}</td>
        </tr>
        <tr>
          <td>现金账户名称：{{ dynamicValidateForm.cashaccountname }}</td>
          <td>现金帐户当前金额：{{ dynamicValidateForm.cashcurmoney }}</td>
					<td>流水号：{{dynamicValidateForm.id}}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>


<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import Export from "@/components/Export/index.vue";

import {
  cashtobank_input,
  cashtobank_save,
  cashtobank_list,
  cashtobank_checkinput,
  cashtobank_export,
  cashtobank_exportexcel,
  cashtobank_exportsave,
} from "@/request/api/allChildrenProject";
import {
  _pictureupload_save,
  _account_dialogcashresult,
  _account_dialogbankresult,
} from "@/request/api/public";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import {
  _bankorcash,
} from "@/assets/js/filedValueFlag";

export default {
  mixins: [part],
  name: "cashtobank",
  components: { Export },
  props: {
    account_dialogcashresult: {
      default: () => _account_dialogcashresult,
    },
    account_dialogbankresult: {
      default: () => _account_dialogbankresult,
    },

    exportUrl: {
      default: () => cashtobank_export,
    },

    exportexcelUrl: {
      default: () => cashtobank_exportexcel,
    },

    exportsaveUrl: {
      default: () => cashtobank_exportsave,
    },
    bankorcash: {
      default: () => _bankorcash,
    },
  },
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!(value + "")) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
      transferDialog: false, //导出框
      itemRow: null, //首表格项
      searchForm: {}, // 搜索值
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        bankaccountaccountname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        bankaccountcurmoney: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        companyorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        amount: [{ trigger: "blur", message: "必填字段", required: true }],
        optime: [{ trigger: "blur", message: "必填字段", required: true }],
        cashaccountname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
      }, //表单规则
      dialogTitle: "", //对话框标题

      selectTable: {},
      selectTableUrl: null,
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      selectSearchForm: {},

      selectSchoolorgid: null,
			key: '',
      showBanknameModal: false, // 选择现金账户
      showDetailModal: false,
      showAccountnameModal: false, // 选择银行账户
    };
  },
  created() {
    this.getDataList();
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", ["org_combox", "org_comboxchild"]),
    //改变分公司 change
    onChangeCompany(val, form) {
      this[form].schoolorgname = "";
      this[form].companyorgid = val;
      this.org_comboxchild(val);
    },
    onChangeSchool(val, form) {
      this[form].schoolorgid = val;
    },
    btnExport() {
      this.transferDialog = true;
    },
    //关闭导出框
    onCloseExport(bool) {
      this.transferDialog = false;
    },
		selectQuery() {
			this.selectSearchForm = {
				accountname: null,
				schoolorgname: null,
				bankname: null,
				cardno: null
			}
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, null);
		},
		reset() {
			this.searchForm = {
				cashaccountname: null,
				schoolorgname: null,
				amount:null,
				username: null
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: cashtobank_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    // 查看详情 click
    btnShowDetail(row) {
      this.dynamicValidateForm = JSON.parse(JSON.stringify(row));
      this.showDetailModal = true;
    },
    //确认银行账户 click
    onConfirmAccountname() {
      selectCheck(this.multipleSelection, "银行账户", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "bankaccountaccountname",
          this.multipleSelection[0].accountname
        );
        this.$set(
          this.dynamicValidateForm,
          "cardno",
          this.multipleSelection[0].cardno
        );
        this.$set(
          this.dynamicValidateForm,
          "bankaccountcurmoney",
          this.multipleSelection[0].curmoney
        );
        this.$set(
          this.dynamicValidateForm,
          "companyorgname",
          this.multipleSelection[0].companyorgname
        );
        this.$set(
          this.dynamicValidateForm,
          "schoolorgname",
          this.multipleSelection[0].schoolorgname
        );
        this.dynamicValidateForm.bankaccountid = this.multipleSelection[0].id;
        this.showAccountnameModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },

    //确认现金账户 click
    onConfirmBankname(modal) {
      selectCheck(this.multipleSelection, "现金账户", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "cashaccountname",
          this.multipleSelection[0].accountname
        );
        this.$set(
          this.dynamicValidateForm,
          "companyorgnamecash",
          this.multipleSelection[0].companyorgname
        );
        this.$set(
          this.dynamicValidateForm,
          "schoolorgnamecash",
          this.multipleSelection[0].schoolorgname
        );
        this.$set(
          this.dynamicValidateForm,
          "cashcurmoney",
          this.multipleSelection[0].curmoney
        );
        this.dynamicValidateForm.cashid = this.multipleSelection[0].id;
        this.showBanknameModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },

    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    //添加click
    btnAdd() {
      myRequest({
        url: cashtobank_checkinput,
      }).then((res) => {
        if (res.data.code === "200") {
          this.dialogTitle = "添加";
          this.dynamicValidateForm = {
            schoolorgid: this.$store.state.login.userinfo.schoolorgid,
            companyorgid: this.$store.state.login.userinfo.companyorgid,
          };
          this.$set(
            this.dynamicValidateForm,
            "companyorgname",
            this.$store.state.login.userinfo.companyorgname
          );
          this.$set(
            this.dynamicValidateForm,
            "schoolorgname",
            this.$store.state.login.userinfo.schoolorgname
          );
          this.org_comboxchild(this.dynamicValidateForm.companyorgid);
          this.showAddModal = true;
        }
      });
    },
    //刷新 click
    btnReload() {
      this.getDataList();
    },

    //提交-（添加，修改） api
    submitAddOrEditForm(formName) {
      this.dynamicValidateForm.optime = formatDare(
        this.dynamicValidateForm.optime,
        "YYYY-MM-DD hh:mm:ss"
      );
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: cashtobank_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,

              modal: "showAddModal",
            }
          );
        }
      });
    },

    //切换选项表格页
    handleSelectChange(val, data) {
      this.selectPageInfo.pageindex = val;
      this.onSelectData(this.selectTableUrl, null, data);
			this.onCloseSelect();
    },

    //选项表格 api(德立学生)
    onSelectData(url, modal, data) {
      this.selectTableUrl = url;
      myRequest({
        url: this.selectTableUrl,
        data: Object.assign(data || {}, this.selectPageInfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
          this.selectTable = res.data.data;
					this.key = Math.random();
          this[modal] = true;
        }
      });
    },
    //选项表格 - 搜索 click
    onSelectSearchClick(url, modal, data) {
      this.selectPageInfo.pageindex = 1;
      this.onSelectData(url, modal, data);
    },
    //关闭选项框 click
    onCloseSelect() {
      this.selectPageInfo.pageindex = 1;
    },

    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style  lang="scss">
	.base_table{
		margin: auto;
	}
</style>